module.exports = __webpack_public_path__ + "static/img/flying-doctors-korea.a96affa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/flying-doctors-korea.jpg
// module id = Yrv6
// module chunks = 0